// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-dialog__body{padding:10px 20px}.setAcc p{line-height:30px}.setAcc .detail{display:flex}", ""]);
// Exports
module.exports = exports;
